import React from "react";

export const SoleSourceTitle = ({ hideWKTrademark }) => (
    <div className="p1s-title">
        <div className="sole-source-trademark">SoleSource<span className="trade-sign">&reg;</span></div>
        {!hideWKTrademark && <div className="wolters-kluwer-trademark">Wolters Kluwer&reg;</div>}
    </div>
);

export default SoleSourceTitle;
